import { UserConfirmation as UserConfirmationPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/register/confirmation")({
  component: UserConfirmationPage,
  beforeLoad: () => {
    document.title = "Maifud - Registro Confirmación";
  },
});
